module.exports = __webpack_public_path__ + "static/media/undraw_takeout_boxes_ap54.c83ad10a.svg";